import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Icon = ({ use, classes = '', ...otherProps }) => (
  <FontAwesomeIcon icon={use} fixedWidth {...otherProps} />
);

export default memo(Icon);
